/**
 * REAPI returns names, phones, and emails as separate arrays keyed by personId.
 * Array index does NOT mean the same contact — phones[0] often belongs to a
 * different person than names[0]. Align arrays to names order so Contact N
 * columns/display rows stay matched.
 */
export function alignSkipTraceResults(results) {
  if (!results?.identity?.names?.length) return results

  const names = results.identity.names
  const phones = results.identity.phones || []
  const emails = results.identity.emails || []
  const jobs = results.demographics?.jobs || []
  const primaryAddress = results.identity?.address

  const alignedPhones = []
  const alignedEmails = []
  const alignedJobs = []
  const alignedAddresses = []

  names.forEach((person, index) => {
    const personId = person?.personId
    if (!personId) {
      alignedPhones[index] = null
      alignedEmails[index] = null
      alignedJobs[index] = null
      alignedAddresses[index] = null
      return
    }
    alignedPhones[index] =
      phones.find((item) => item?.personId === personId) || null
    alignedEmails[index] =
      emails.find((item) => item?.personId === personId) || null
    alignedJobs[index] =
      jobs.find((item) => item?.personId === personId) || null
    alignedAddresses[index] =
      primaryAddress?.personId === personId ? primaryAddress : null
  })

  return {
    ...results,
    identity: {
      ...results.identity,
      phones: alignedPhones,
      emails: alignedEmails,
      // Keep primary address for existing header path; also expose history-style list
      address: alignedAddresses[0] || primaryAddress || null,
      addresses: alignedAddresses,
    },
    demographics: {
      ...results.demographics,
      jobs: alignedJobs,
    },
  }
}

/**
 * Flatten skip-trace output into one contact object per name, matched by personId.
 */
export function reformatSkipTraceData(results) {
  const aligned = alignSkipTraceResults(results)
  const phones = aligned?.identity?.phones || []
  const emails = aligned?.identity?.emails || []
  const jobs = aligned?.demographics?.jobs || []
  const addresses = aligned?.identity?.addresses || []
  const demographics = aligned?.demographics || {}
  const primaryPersonId = aligned?.identity?.address?.personId

  return (aligned?.identity?.names || []).map((person, index) => {
    const isPrimary =
      person?.personId && person.personId === primaryPersonId
    return {
      ...person,
      address: addresses[index] || null,
      phone: phones[index] || null,
      email: emails[index] || null,
      job: jobs[index] || null,
      // Demographics from REAPI are for the primary matched person only
      gender: isPrimary ? demographics.gender : null,
      age: isPrimary ? demographics.ageDisplay : null,
      dob: isPrimary ? demographics.dob : null,
    }
  })
}
